import Vue from "vue";
import Vuetify from "vuetify";
import router from "../router";

Vue.use(Vuetify);

console.log(`Loading Vuetify, version: ${Vuetify.version}`);

export const plugins = {
  router,
  vuetify: new Vuetify({
    //Icon library definitions to be used on this view.
    icons: {
      iconfont: "mdi" || "md" || "fa" || "faSvg"
    },
    breakpoint: {
      mobileBreakpoint: 1195
    }
  })
};

